import bigcommerceGenericDefaults from '../bigcommerce-generic/config.js';

const baseFitmentFields = ['Year', 'Make', 'Bed'];
const extraFitmentFields = [];

window.Convermax.handleProductCompareClick = () => {
  const productsIdsToCompare = [...window.document.querySelectorAll('input[name="products[]"]:checked')].map(
    (product) => product.dataset.compareId,
  );
  const compareBtn = window.document.body.querySelector('.cm_card-compare_link');
  const compareCount = window.document.body.querySelector('.cm_card-compare_count');
  if (!compareBtn) {
    return;
  }

  compareCount.textContent = productsIdsToCompare.length;
  compareBtn.classList.toggle('show', productsIdsToCompare.length > 1);
  compareBtn.href = `/compare/${productsIdsToCompare.join('/')}/`;
};

export default {
  includes: ['bigcommerce-generic'],
  ...bigcommerceGenericDefaults,
  fitmentSearch: {
    ...bigcommerceGenericDefaults.fitmentSearch,
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
  },
  pagination: {
    centralRange: 1,
    edgeRange: 1,
  },
  Widgets: [
    ...bigcommerceGenericDefaults.Widgets.filter((w) => !['Garage'].includes(w.name)),
    {
      name: 'Garage',
      location: { selector: '#cm-garage', class: 'cm_garage__container' },
      template: 'fitmentSearch/garage',
    },
  ],
};
